/** rounding to 100% creates the impression that ALL patients have recommended the provider,
 * even if it's only _nearly all_ of them.
 * Accordingly, we never round 99.x to 100 — only ever to 99.
 * Consult with company legal counsel before changing this.
 */
export const ratingRound = (percentage: number) =>
  percentage < 99 ? Math.round(percentage) : Math.floor(percentage);
